import React, { Component, memo } from 'react'
import styled, { css } from 'styled-components'
import StolLogo from '../../images/StolLogo'
import Text from '../Text'
import AdblockMessage from './images/check.gif'
import HTMLReactParser from 'html-react-parser'
import translate from '../../modules/translate'
import ReactGA from 'react-ga'
import Image from '../Image'
import { createUuid } from '../../modules/uuid'
import { useDetectAdBlock } from 'adblock-detect-react'
import pushEventToDataLayer from '../../modules/push-event-to-data-layer'

const Wrapper = styled.div`
  width: ${(props) => props.theme.breakPoint + 'px'};
  display: none;
  background-color: rgba(255, 255, 255);
  padding-bottom: ${(props) => props.theme.sizes.gapVerticalHalf};
  padding-top: ${(props) => props.theme.sizes.gapVerticalHalf};
  background-color: white;
  margin-bottom: calc(${(props) => props.theme.sizes.gapVerticalHalf} - 150px);
  align-self: center;
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 600 + 'px'}) {
    align-self: baseline;
    margin-left: calc((100% - 1080px - 160px - 300px) / 2 + 160px);
  }
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 460 + 'px'}) {
    align-self: baseline;
    margin-left: calc((100% - 1080px - 300px) / 2);
  }
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 300 + 'px'}) {
    align-self: center;
    margin-left: 0;
  }
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    width: 100%;
    padding-bottom: ${(props) => props.theme.tablet.sizes.gapVerticalHalf};
    padding-top: ${(props) => props.theme.tablet.sizes.gapVerticalHalf};
  }
  @media (max-width: ${(props) => props.theme.tablet.breakPoint - 61 + 'px'}) {
    margin-bottom: ${(props) => props.theme.tablet.sizes.gapVerticalHalf};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    padding-bottom: ${(props) => props.theme.mobile.sizes.gapVerticalHalf};
    padding-top: ${(props) => props.theme.mobile.sizes.gapVerticalHalf};
    margin-bottom: ${(props) => props.theme.mobile.sizes.gapVerticalHalf};
  }
  -webkit-box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.35);
  -moz-box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.35);
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.35);
  ${(props) =>
    props.adsAreBlocked &&
    css`
      display: flex;
    `}
`

const LeftWrapper = styled.div`
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  display: flex;
  padding-right: ${(props) => props.theme.sizes.gapEdge};
  padding-left: ${(props) => props.theme.sizes.gapEdge};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    padding-right: ${(props) => props.theme.tablet.sizes.gapEdge};
    padding-left: ${(props) => props.theme.tablet.sizes.gapEdge};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    padding-right: ${(props) => props.theme.mobile.sizes.gapEdge};
    padding-left: ${(props) => props.theme.mobile.sizes.gapEdge};
  }
`

const RightWrapper = styled.div`
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  display: flex;
  padding-right: ${(props) => props.theme.sizes.gapEdge};
  padding-left: ${(props) => props.theme.sizes.gapEdge};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    padding-right: ${(props) => props.theme.tablet.sizes.gapEdge};
    padding-left: ${(props) => props.theme.tablet.sizes.gapEdge};
    display: none;
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    padding-right: ${(props) => props.theme.mobile.sizes.gapEdge};
    padding-left: ${(props) => props.theme.mobile.sizes.gapEdge};
    display: none;
  }
`

const StyledText = styled(Text)`
  margin-top: 10px;
`

const StolLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`

const StyledLogo = styled(StolLogo)`
  width: 130px;
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    width: 90px;
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    width: 90px;
  }
`

const StyledFirstMessageText = styled(Text)`
  padding-left: 10px;
  padding-right: 10px;
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.tablet.fontSize.small};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.mobile.fontSize.small};
  }
`

const StyledSecondMessageText = styled(Text)`
  margin-top: 10px;
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.tablet.fontSize.small};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.mobile.fontSize.small};
  }
`

const StyledMessagImage = styled(Image)``

const WrapperTasks = styled.div`
  text-align: left;
`

const AdBlockMessage = (props) => {
  const adBlockDetected = useDetectAdBlock()

  if (!adBlockDetected) {
    return false
  }

  ReactGA.event({ category: 'Adblock', action: 'show banner' })
  pushEventToDataLayer('AdBlockMessage')
  return (
    <Wrapper id={createUuid()} adsAreBlocked="true" {...props}>
      <LeftWrapper id={createUuid()}>
        <StolLogoWrapper id={createUuid()}>
          <StyledLogo id={createUuid()} />
          <StyledFirstMessageText id={createUuid()}>{translate('adblock_message_1')}</StyledFirstMessageText>
        </StolLogoWrapper>
        <StyledSecondMessageText id={createUuid()}>
          {HTMLReactParser(translate('adblock_message_2'))}
        </StyledSecondMessageText>
      </LeftWrapper>
      <RightWrapper id={createUuid()}>
        <div id={createUuid()}>
          <StyledMessagImage id={createUuid()} width={364} height={180} src={AdblockMessage} />
        </div>
        <WrapperTasks id={createUuid()}>
          <StyledText id={createUuid()}>{translate('adblock_task_1')}</StyledText>
          <StyledText id={createUuid()}>{translate('adblock_task_2')}</StyledText>
        </WrapperTasks>
      </RightWrapper>
    </Wrapper>
  )
}

export default memo(AdBlockMessage)
